import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const Default = styled.div`
  display: flex;
  align-items: flex-start;
  padding: var(--space-3) var(--space-5);
  ${Typography.body_xs}
  color: var(--text-primary);
  background: var(--background-muted);
  border-radius: var(--border-radius-4);
`;

const RightRow = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
`;

const Status = styled.div`
  max-width: 453px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  align-items: flex-start;
  border-top: 0.5px solid var(--border-primary);
  padding-top: var(--space-12);
`;

const StatusRow = styled.div`
  ${FlexBetween}
  padding: var(--space-6) var(--space-8);
  width: -webkit-fill-available;
  gap: var(--space-10);
  .active-state {
    border-radius: var(--border-radius-6);
    background-color: var(--background-muted);
  }
`;

export { Default, RightRow, StatusRow, Status };
